import React from "react";
import { useNavigate } from "react-router-dom";

function SupplierTerms() {
  const navigate = useNavigate();
  const handleClickHome = () => {
    navigate("/");
  };
  return (
    <div className="login-page py-4">
      <div className="container">
        <h2 className="mb-4 text-center">Terms &amp; Conditions</h2>
        <ol>
          <li>
            <h5>Program Participation</h5>
            <p>
              You’re joining the Touch-It scavenger hunt and booking program.
              It’s 100% free and always optional. All we ask is that you display
              at least one promotional item while you're participating.
            </p>
          </li>
          <li className="mb-3">
            <h5>Commission Structure</h5>
            <p>
              <strong>Company earns:</strong> 5% of all lifetime bookings made
              by customers who download the app via your custom QR code or link.
              Commissions are paid within 48 hours of each completed booking.
            </p>
            <p>
              <strong>Staff earn:</strong>
            </p>
            <ul>
              <li>$1.00 for every verified app download</li>
              <li>$5.00 when that customer completes their first booking</li>
              <li>Bonuses are paid monthly.</li>
            </ul>
          </li>
          <li>
            <h5>Customer Ownership</h5>
            <p>
              Every customer you refer is permanently linked to your business.
              You keep earning on anything they book through the app, even if
              it’s unrelated to your business.
            </p>
          </li>
          <li>
            <h5>Supplier Portal Access</h5>
            <p>
              You get access to a live dashboard showing commissions, referrals,
              payments, and your listing tools.
            </p>
          </li>
          <li>
            <h5>Promotional Materials</h5>
            <p>
              All materials are supplied free of charge. Just keep one on
              display while active and through January 31st 2026.
            </p>
          </li>
          <li>
            <h5>Commission Continuation</h5>
            <p>
              Commissions stay active while you’re participating. If you stop,
              future commissions end. Anything already earned remains yours — we
              never claw that back.
            </p>
          </li>
          <li>
            <h5>Tracking &amp; Data</h5>
            <p>
              All bonuses and commissions are based on our system data. Disputes
              will be reviewed fairly and promptly.
            </p>
          </li>
          <li>
            <h5>Ending the Program</h5>
            <p>
              Either of us can end participation anytime with 30 days’ notice.
              You’ll still get paid everything you’ve earned to date.
            </p>
          </li>
          <li>
            <h5>General Info</h5>
            <p>
              This is a supplier agreement — not a legal partnership or
              employment relationship. Governed by Queensland law.
            </p>
          </li>
          <li>
            <h5>Hunt Location Participation (High-Impact Exposure)</h5>
            <ul>
              <li>
                Hunt Locations are featured in live scavenger hunts — seen by
                every app user during peak campaigns.
              </li>
              <li>Drive real walk-ins, boost visibility, and grow bookings.</li>
              <li>
                Free until December 31, 2025, including Schoolies and peak
                season.
              </li>
              <li>
                After that, paid plans offer guaranteed monthly hunt placements.
                Higher tiers mean more exposure.
              </li>
              <li>
                To qualify, simply offer one in-app customer incentive (like a
                discount, bonus, or upgrade) — all managed in your Supplier
                Portal.
              </li>
            </ul>
          </li>
        </ol>
      </div>
    </div>
  );
}

export default SupplierTerms;
